import { render, staticRenderFns } from "./AdminCompanyView.vue?vue&type=template&id=5fb264b7&scoped=true"
import script from "./AdminCompanyView.vue?vue&type=script&lang=js"
export * from "./AdminCompanyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb264b7",
  null
  
)

export default component.exports